/**
 * Formats an AWS service name from the format "AWS::ServiceName::ResourceType" to "ServiceName ResourceType"
 * @param serviceName - The AWS service name in the format "AWS::ServiceName::ResourceType"
 * @returns The formatted service name in the format "ServiceName ResourceType"
 * @example
 * formatServiceName("AWS::SNS::Topic") // returns "SNS Topic"
 */
export const formatServiceName = (serviceName: string): string => {
  // Split the service name by "::" and remove the "AWS" prefix
  const parts = serviceName.split("::");

  // If the service name doesn't have the expected format, return it as is
  if (parts.length < 3 || parts.at(0) !== "AWS") {
    return serviceName;
  }

  // Extract the service name and resource type
  const service = parts.at(1);
  const resourceType = parts.at(2);

  // Return the formatted service name
  return `${service ?? ""} ${resourceType ?? ""}`;
};
